<script setup lang="ts">
import ClasswalletOrderBrowser from '~components/admin/ClasswalletOrderBrowser.vue'
import SelfLink from '~components/widgets/SelfLink.vue'
</script>

<template>
  <b-container fluid>
    <h1><self-link href="/admin/orders/classwallet">Classwallet Orders</self-link></h1>
    <hr>
    <classwallet-order-browser />
  </b-container>
</template>
